
export const ROUTES = {
  VERIFY_3DS_SUCCESS: window.location.pathname.startsWith('/asb') ? '/asb/3ds-success' : '/3ds-success',
  VERIFY_3DS_FAIL: window.location.pathname.startsWith('/asb') ? '/asb/3ds-fail' : '/3ds-fail',
};
